import React, { useEffect, useState } from 'react';
import SubHeader from "components/menu/SubHeader";
import { FatigueAssessmentPageSelector } from "./FatigueAssessmentPageSelector";
import { FatigueAssessmentSidebar } from "./FatigueAssessmentSidebar";
import { ReactComponent as FatigueAssessmentIcon } from "assets/icons/fatigue-assessment-filled.svg";
import './FatigueAssessments.css'
import { ISelectOption } from '../forms/util';


interface FatigueAssessmentPageProps {
    selectedPage: ISelectOption,
    children?: React.ReactNode
}

const FatigueAssessmentPage = (props: FatigueAssessmentPageProps) => {
    const [currentSelection] = useState(props.selectedPage);

    useEffect(() => {

    }, []);

    return (
        <>
            <div className="fatigue-assessments">
                <div className="fatigue-header-bg"></div>
                <div className="narrow-container">
                    <SubHeader />
                    <div className="fatigue-assessments-page">
                        <div className="fatigue-assessments-heading fa-narrow">
                            <FatigueAssessmentIcon />
                            Fatigue Assessment
                        </div>
                        <FatigueAssessmentPageSelector selectedPage={currentSelection} />

                        <div className="row">
                            <div className="fa-wide col-3">
                                <FatigueAssessmentSidebar selectedPage={currentSelection} />
                            </div>
                            <div className="col">
                                <React.Fragment>{props.children}</React.Fragment>
                            </div>
                        </div>

                        <div className="fatigue-assessments-footer"></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FatigueAssessmentPage;
